import React from 'react';

export const Card = ({ title, value, icon, children }) => (
    <div className="bg-white p-5 rounded-lg shadow-md flex items-center relative">
        <div className="p-3 rounded-full bg-blue-100 text-blue-600 mr-4">{icon}</div>
        <div>
            <h3 className="text-sm font-medium text-gray-500">{title}</h3>
            <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
        {children && <div className="absolute top-2 right-2">{children}</div>}
    </div>
);